import { writable } from "svelte/store";

export const retechInfo = writable(null);
export const retech_jwt_token = writable(null);
export const retech_refresh_token = writable(null);
